import { Plus, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import type { DataGridProps } from './types';

export function DataGridToolbar<T>(props: DataGridProps<T>) {
  const {
    title,
    searchPlaceholder,
    search,
    onSearchChange,
    total,
    showAddButton,
    addButtonText = 'Add Item',
    onAddClick,
    showPageIndicator,
    pageNumber,
    totalPages,
    toolbarActions,
  } = props;

  return (
    <div className="flex flex-wrap items-center gap-3 border-b p-3">
      <div className="flex flex-col">
        <h2 className="text-base font-semibold">{title}</h2>
        <span className="text-xs text-muted-foreground">{total} total</span>
      </div>

      {toolbarActions}

      <div className="relative ml-auto w-64">
        <Search className="absolute left-2 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="pl-8"
        />
      </div>

      {showPageIndicator && pageNumber != null && totalPages != null && (
        <span className="text-xs text-muted-foreground">
          Page {pageNumber} of {totalPages}
        </span>
      )}

      {showAddButton && (
        <Button size="sm" onClick={onAddClick}>
          <Plus /> {addButtonText}
        </Button>
      )}
    </div>
  );
}
